module.exports = __webpack_public_path__ + "static/img/4.fa0510a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/eng/4.png
// module id = oi7M
// module chunks = 0